import FooterDescription from "./FooterDescription";

export default FooterDescription